import React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { Button } from '../ui/button'
import { Moon, Sun } from 'lucide-react'
import { Theme } from '@/providers/Theme/types'
import { cn } from '@/utilities/ui'

const ThemeButton = ({
  theme,
  setTheme,
  className,
}: {
  theme: Theme | null | undefined
  setTheme: (theme: 'light' | 'dark') => void
  className?: string
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="destructive"
          size="sm"
          className={cn(
            '!min-w-fit bg-transparent shadow-none hover:bg-transparent !px-1 py-1 !w-fit text-secondary hover:shadow focus:shadow-none focus:!border-none focus:!outline-none focus:!ring-0 focus:!ring-offset-0 focus:!ring-transparent ',
            className,
          )}
        >
          <Sun
            // size={60}
            className={`text-white rotate-0 !h-6 lg:!h-5 !w-6 lg:!w-5 transition-all duration-300   ${theme === 'dark' ? 'scale-0 -rotate-90' : 'scale-100'}`}
          />
          <Moon
            // size={60}
            className={`text-white absolute !h-6 lg:!h-5 !w-6 lg:!w-5 transition-all duration-300  ${theme === 'dark' ? 'scale-100 rotate-0' : 'scale-0 opacity-0'} `}
          />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme('light')}>Light</DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme('dark')}>Dark</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export default ThemeButton
